import { AuthApiUrl } from '~/server/api/route/url'
import { Context } from '~/types/ext/vue'

export default async function loginRedirect(ctx: Context): Promise<void> {
  if (!ctx.store.state.authUser) {
    return
  }

  try {
    await ctx.$axios.$get(AuthApiUrl.STATUS)
  } catch (e) {
    return
  }

  if (ctx.store.state.authUser) {
    return ctx.redirect('/users/mypage')
  } else {
    return await ctx.$axios.$get(AuthApiUrl.LOGOUT)
  }
}
